module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"viewAllResults":"View all results"},"zh":{"viewAllResults":"查看更多"}}')
  delete Component.options._Ctor
}
